/**
 * Velocity-offset detune shared by both sonification engines.
 *
 * The feature engine's pitch map spans two octaves over 4200–7100 Å, so a
 * physically faithful +2350 km/s Hβ shift would be a third of a semitone and
 * inaudible. Both engines therefore exaggerate velocity offsets by this
 * constant: −1360 km/s ≈ −2 semitones, +2350 km/s ≈ +3.5 semitones.
 */
export const SEMITONES_PER_1000_KMS = 1.5;

/** Frequency multiplier for a line whose peak sits `kms` off its rest wavelength. */
export function velocityDetuneRatio(kms: number): number {
  return Math.pow(2, ((kms / 1000) * SEMITONES_PER_1000_KMS) / 12);
}
